module.exports = __webpack_public_path__ + "static/media/delahuerta.258f5f0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/marcas/delahuerta.png
// module id = 973
// module chunks = 0